import { render, staticRenderFns } from "./Ingreso.vue?vue&type=template&id=c87655f8&scoped=true&"
import script from "./Ingreso.vue?vue&type=script&lang=js&"
export * from "./Ingreso.vue?vue&type=script&lang=js&"
import style0 from "./Ingreso.vue?vue&type=style&index=0&id=c87655f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87655f8",
  null
  
)

export default component.exports